/** Telefones BR: normalização E.164, formatação para exibição e link wa.me. */
/**
 * Normaliza para o formato usado pelo WhatsApp: `55` + DDD + número, só dígitos.
 * Aceita entradas com ou sem máscara, com ou sem o `55`. Retorna `null` quando
 * não dá pra chegar num número BR plausível (10 ou 11 dígitos após o DDD).
 */
export function normalizePhoneBR(raw) {
    let digits = (raw ?? "").replace(/\D/g, "");
    if (digits.startsWith("55") && digits.length > 11) {
        digits = digits.slice(2);
    }
    // DDD (2) + assinante (8 fixo ou 9 móvel)
    if (digits.length !== 10 && digits.length !== 11)
        return null;
    return `55${digits}`;
}
/** `(11) 99999-8888` a partir de qualquer entrada; devolve a entrada crua se não normalizar. */
export function formatPhoneBR(raw) {
    const n = normalizePhoneBR(raw);
    if (!n)
        return raw ?? "";
    const local = n.slice(2);
    const ddd = local.slice(0, 2);
    const sub = local.slice(2);
    const mid = sub.length === 9 ? sub.slice(0, 5) : sub.slice(0, 4);
    const end = sub.length === 9 ? sub.slice(5) : sub.slice(4);
    return `(${ddd}) ${mid}-${end}`;
}
/** `tel:+55...` para telefone clicável. */
export function telLink(raw) {
    const n = normalizePhoneBR(raw);
    return n ? `tel:+${n}` : `tel:${(raw ?? "").replace(/[^\d+]/g, "")}`;
}
/** Link `https://wa.me/55...?text=...` com mensagem pré-preenchida (opcional). */
export function waLink(raw, message) {
    const n = normalizePhoneBR(raw);
    if (!n)
        return null;
    const base = `https://wa.me/${n}`;
    return message ? `${base}?text=${encodeURIComponent(message)}` : base;
}
//# sourceMappingURL=phone.js.map